import React, { useState } from "react";
import { LoginForm } from "../../../components/LoginForm";
import { SignupForm } from "../../../components/SignupForm";
import { AccountContext } from "../../../context/accountContext";
import { CommunityLoginHomeDiv } from "../../../styles/communityCommon";
import { CommunityLoginCss } from "../../../styles/communityLogin";

const expandingTransition = {
  type: "spring",
  duration: 2.3,
  stiffness: 30,
};

const CommunityLogin = (props) => {
  const [isExpanded, setExpanded] = useState(false);
  const [active, setActive] = useState("signin");

  const playExpandingAnimation = () => {
    setExpanded(true);
    setTimeout(() => {
      setExpanded(false);
    }, expandingTransition.duration * 1000 - 1500);
  };

  const switchToSignup = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signup");
    }, 400);
  };

  const switchToSignin = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signin");
    }, 400);
  };

  const contextValue = { switchToSignup, switchToSignin };

  return (
    <AccountContext.Provider value={contextValue}>
      <CommunityLoginHomeDiv>
        <CommunityLoginCss.BoxContainer>
          <CommunityLoginCss.TopContainer>
            <CommunityLoginCss.BackDrop
              initial={false}
              animate={isExpanded ? "expanded" : "collapsed"}
              variants={CommunityLoginCss.backdropVariants}
              transition={expandingTransition}
            />
            {active === "signin" && (
              <CommunityLoginCss.HeaderContainer>
                <CommunityLoginCss.HeaderText>
                  Welcome
                </CommunityLoginCss.HeaderText>
                <CommunityLoginCss.HeaderText>
                  Back
                </CommunityLoginCss.HeaderText>
                <CommunityLoginCss.SmallText>
                  Please sign-in to continue!
                </CommunityLoginCss.SmallText>
              </CommunityLoginCss.HeaderContainer>
            )}
            {active === "signup" && (
              <CommunityLoginCss.HeaderContainer>
                <CommunityLoginCss.HeaderText>
                  Create
                </CommunityLoginCss.HeaderText>
                <CommunityLoginCss.HeaderText>
                  Account
                </CommunityLoginCss.HeaderText>
                <CommunityLoginCss.SmallText>
                  Please sign-up to continue!
                </CommunityLoginCss.SmallText>
              </CommunityLoginCss.HeaderContainer>
            )}
          </CommunityLoginCss.TopContainer>
          <CommunityLoginCss.InnerContainer>
            {active === "signin" && <LoginForm onChange={props.onChange} />}
            {active === "signup" && <SignupForm />}
          </CommunityLoginCss.InnerContainer>
        </CommunityLoginCss.BoxContainer>
      </CommunityLoginHomeDiv>
    </AccountContext.Provider>
  );
};

export default CommunityLogin;
